import { SheetRenderer } from "@/components/r3f/renderers/sheet-renderer";
import { SheetObject } from "@/object-cache";
import { FloorPlanBackgroundTransparency } from "@faro-lotv/lotv";
import { JSX } from "react";

type FlyWalkOrthomosaicRendererProps = {
  /** The current active Orthomosaic */
  orthomosaic: SheetObject | null;
};

/** @returns A component to render an OrthomosaicObject in the correct pose. */
export function FlyWalkOrthomosaicRenderer({
  orthomosaic,
}: FlyWalkOrthomosaicRendererProps): JSX.Element | null {
  if (!orthomosaic) {
    return null;
  }

  return (
    <SheetRenderer
      sheet={orthomosaic}
      transparent={false}
      backgroundTransparent={FloorPlanBackgroundTransparency.No}
      dark={false}
    />
  );
}
